// material-ui
import { Box } from '@mui/material';

// project import
import MainCard, { MainCardProps } from 'ui-component/cards/MainCard';

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

const AuthCardWrapper = ({ children, ...other }: MainCardProps) => (
    <MainCard
        sx={{
            borderRadius: '10px',
            maxWidth: { xs: 400, lg: 500 },
            p: '24px 12px',
            '& > *': {
                flexGrow: 1,
                flexBasis: '50%'
            }
        }}
        content={false}
        {...other}
    >
        <Box height="100%" width="100%">
            {children}
        </Box>
    </MainCard>
);

export default AuthCardWrapper;
